import React, { createContext, useState } from "react";
import PMSIncomeCategoryServices from "../../services/pms_services/PMSIncomeCategoryServices";
import Notification from "../../components/common/Notification";

export const PMSIncomeCategoryContext = createContext("PMSIncomeCategoryContext");

const PMSIncomeCategoryContextProvider = ({ children }) => {

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [incomeCategories, setIncomeCategories] = useState([]);
    const [totalElements, setTotalElements] = useState(0);

    const getAllIncomeCategoriesByPharmacyId = async (pharmacyId, params = {}) => {
        try {
            setLoading(true);
            setErrorMsg("");

            console.log("Fetching income categories for pharmacy:", pharmacyId, "with params:", params);
            const res = await PMSIncomeCategoryServices.getAllIncomeCategoriesByPharmacyId(pharmacyId, params);

            console.log("Income categories response:", res.data);
            setIncomeCategories(res.data.content || res.data || []);
            setTotalElements(res.data.totalElements || res.data.length || 0);
            setLoading(false);
            return res.data.content || res.data || [];
        } catch (error) {
            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }

            setErrorMsg(_error);
            console.error("Error fetching income categories:", error);
            return [];
        }
    };

    const createIncomeCategoryByPharmacyId = async (id, data) => {

        try {
            setLoading(true);
            setErrorMsg("");

            await PMSIncomeCategoryServices.createIncomeCategoryByPharmacyId(id, data);

            Notification("success", "Added", "Income category has been added successfully!");

            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }

            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    }

    return (
        <PMSIncomeCategoryContext.Provider
            value={{
                loading,
                errorMsg,
                incomeCategories,
                totalElements,
                getAllIncomeCategoriesByPharmacyId,
                createIncomeCategoryByPharmacyId
            }}
        >
            {children}
        </PMSIncomeCategoryContext.Provider>
    )
}

export default PMSIncomeCategoryContextProvider;